import { connect } from 'react-redux';
import jwtDecode from 'jwt-decode';
import React from 'react';
import ReactDOM from 'react-dom';
import 'react-toastify/dist/ReactToastify.css';
import Cms, {
  ToastContainer,
  setAccessToken,
  StateHOF,
  EmailPasswordLogin,
  ForgotPassword,
} from './byob-cms';

// import 'byob-cms/src/stylesheets/bootstrap-override.css';
import './byob-cms/src/stylesheets/react-selectize.css';
import './byob-cms/src/stylesheets/react-jsonschemaform.css';

import './main.css';
import './encouragement.webflow.css';
import './custom.css';
import AdminGqlCmsConfig from './AdminGqlCmsConfig';
import ContentEditorGqlCmsConfig from './ContentEditorGqlCmsConfig';
import CuratorGqlCmsConfig from './CuratorGqlCmsConfig';

if (process.env.NODE_ENV !== 'development' && window.Raven) {
  window.Raven.config(process.env.REACT_APP_SENTRY_DSN).install();
}

class RoleRouter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      forgotPassword: false,
    };
  }
  render() {
    const { accessToken } = this.props;
    const { forgotPassword } = this.state;
    if (!accessToken) {
      return (
        <div>
          <ToastContainer
            position="top-center"
            type="default"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            pauseOnHover
          />
          {!forgotPassword ? (
            <EmailPasswordLogin
              onSwitch={screen => this.setState({ [screen]: !this.state[screen] })}
            />
          ) : (
            <ForgotPassword onSwitch={screen => this.setState({ [screen]: !this.state[screen] })} />
          )}
        </div>
      );
    }
    const { roles } = jwtDecode(accessToken);
    if (roles && roles.length) {
      if (roles.includes('ADMIN')) {
        return <Cms config={AdminGqlCmsConfig} />;
      } else if (roles.includes('EDITOR')) {
        return <Cms config={ContentEditorGqlCmsConfig} />;
      } else if (roles.includes('CURATOR')) {
        return <Cms config={CuratorGqlCmsConfig} />;
      }
    }
    setTimeout(() => {
      this.props.setAccessToken(null);
    });
    return null;
  }
}

const RoleRouterWithState = StateHOF(
  connect(
    state => ({ accessToken: state.accessToken }),
    { setAccessToken },
  )(RoleRouter),
);

ReactDOM.render(
  <RoleRouterWithState config={AdminGqlCmsConfig} />,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js